import React, { useContext } from 'react'
import classNames from 'classnames'
import { bool, node, string, shape } from 'prop-types'

import { ThemeContext } from '@/component/Context/ThemeContext'
import styles from './Prose.module.scss'

const Prose = ({
  children,
  className,
  dangerousHtml,
  inverse,
  options = {}
}) => {
  const { theme, brandType } = useContext(ThemeContext)
  if (!children && !dangerousHtml) return null
  return (
    <div
      className={classNames(
        styles.Prose,
        inverse && styles.inverse,
        theme && styles[theme],
        brandType !== 'B2B' && styles.noTicker,
        className
      )}
      {...(dangerousHtml && {
        dangerouslySetInnerHTML: { __html: dangerousHtml }
      })}
    >
      {children}
    </div>
  )
}

Prose.propTypes = {
  children: node,
  className: string,
  dangerousHtml: string,
  inverse: bool,
  color: string,
  options: shape({})
}

export default Prose
